"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getError = void 0;
var React = require("react");
var getError = function (index, e) {
    return e.foldL(function () { return React.createElement("span", { key: "validation-".concat(index), className: 'validation-error' }); }, function (errors) {
        if (errors[index] && errors[index].length > 0) {
            return (React.createElement("span", { key: "validation-".concat(index), className: 'validation-error' }, errors[index][0]));
        }
        return React.createElement("span", { key: "validation-".concat(index), className: 'validation-error' });
    });
};
exports.getError = getError;
